import React, { useEffect, useState } from 'react'
import { RxCross2 } from 'react-icons/rx'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import AppointmentTable from '../components/appointmentTable'
import AppointmentCalendar from '../components/AppointmentCalendar'
import Header from '../components/header'
import AppLayout from '../components/AppLayout'
import { useTenant } from '../context/TenantContext'
import { useLabels } from '../utils/labels'
import { addbusinessAppointment, cancelBusinessAppointment, completeBusinessAppointment, deleteBusinessAppointment, editBusinessServices, getBusinessAppointment, getBusinessPatients, getBusinessDetails, getBusinessServices, getBusinessStaff, rescheduleBusinessAppointment, updateAppointmentStatus } from '../logic/business/action'
import { Checkbox, Grid, IconButton, Snackbar, Button, Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, Paper, Divider } from '@mui/material'
import { MdArrowBackIos, MdArrowForwardIos, MdClose, MdRefresh, MdSearch } from 'react-icons/md'
import { failedBookAppointment, removeAppointmentError } from '../logic/business/reducer'
import InputComponents from '../components/input'
import { DateField, DatePicker, MobileDatePicker, MobileTimePicker, TimeField } from '@mui/x-date-pickers'
import dayjs from 'dayjs'
import { addDate, removeDate, setInitialDate, setInitialMobileDate } from '../logic/dates/action'
import { setSelectedDate } from '../logic/dates/reducer'
import { compareDate, returnMonth, returnWeek } from '../utils/date'
import AppointmentAccordian from '../components/accordian'
import { RescheduleForm } from '../components/editAppointment'
import { PatientPopup } from './home'
import { AppointmentForm } from '../components/AppointmentForm'
import moment from 'moment'
import { errorMessage, successMessage } from '../logic/error/action'

const AppointmentScreen = () => {
const dispatch = useDispatch();
const { tenant } = useTenant();
const labels = useLabels();
const [dateselected, setdateselected] = useState(`${new Date().getFullYear()}-${new Date().getMonth()+1}-${new Date().getDate()}`);
// const [state, setState] = useState(0);
const [stateForm, setStateForm] = useState({
  name:'',
  role:'',
  email:'',
  contact:'',
});
const [sidebarOpen, setSidebarOpen] = useState(false);
const [sidebarMode, setSidebarMode] = useState("add"); // "add" or "edit"
const [editId, setEditId] = useState(0);
const [selectedAppointmentData, setSelectedAppointmentData] = useState(null);
const [appointmenttoDelete,setAppointmenttodelete] = useState(null);
const [appointmenttoCancel,setAppointmenttocancel] = useState(null);
const [appointmenttoComplete,setAppointmenttocomplete] = useState(null);
const [appointmenttoReschedule,setAppointmenttoreschedule] = useState(null);
const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
const [showConfirmationPopupCancel, setShowConfirmationPopupCancel] = useState(false);
const [showConfirmationPopupComplete, setShowConfirmationPopupComplete] = useState(false);
const [sendNotificationID, setSendNotificationID] = useState(null);
const [showSendNotification, setShowSendNotification] = useState(false);
const [selectedPaymentMethod,setSelectedPaymentMethod] = useState(false);
const [patientName,setPatientName] = useState("");
const [patientID,setPatientID] = useState("");
const [patientDetails,setPatientDetails] = useState("");
const [showPatientDetailsPopUp,setShowPatientDetailsPopUp] = useState("");


const [patientContact,setPatientContact] = useState("");
const [appointmentStatus,setAppointmentStatus] = useState(null);
const [startTime2,setStartTime2] = useState(null);
const [startDate2,setStartDate2] = useState(null);


const [calendarView, setCalendarView] = useState(true); // Toggle between calendar and table view

const selector = useSelector(state=>state.auth);
const businessSelector = useSelector(state=>state.business);
useEffect(() => {
  setInitialDate(dispatch);
  setInitialMobileDate(dispatch);
    getBusinessStaff(dispatch, selector?.user?.business_id);
    getBusinessServices(dispatch, selector?.user?.business_id);
    getBusinessPatients(dispatch, selector?.user?.business_id);
    // getBusinessAppointment(dispatch, selector?.user?.business_id,`${new Date().getFullYear()}-${new Date().getMonth()+1}-${new Date().getDate()}`);
    
    // Check if we should open the sidebar from URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('add') === 'true') {
      setSidebarOpen(true);
      setSidebarMode('add');
      setSelectedAppointmentData(null);
      setEditId(0);
      // Clean up URL
      window.history.replaceState({}, '', window.location.pathname);
    }
}, [selector?.user?.business_id]);
const refreshAppointment = async() => {
    getBusinessAppointment(dispatch, selector?.user?.business_id,`${dateState.selectedDate?.getFullYear()}-${dateState.selectedDate?.getMonth()+1}-${dateState.selectedDate?.getDate()}`);
}


const handlePaymentMethodChange = (method) =>{
  setSelectedPaymentMethod(method);
  // console.log(method);
}
const handleDeleteAppointmentMain =(id)=>{
  deleteBusinessAppointment(dispatch,id);
  setTimeout(() => {
    getBusinessAppointment(dispatch, selector?.user?.business_id,`${dateState.selectedDate?.getFullYear()}-${dateState.selectedDate?.getMonth()+1}-${dateState.selectedDate?.getDate()}`);
  }, 300);

  // console.log(id);
}
const handleCancelAppointmentMain =(id)=>{
  // cancelBusinessAppointment(dispatch,id);
  const startDate = moment(startDate2).format("YYYY-MM-DD");
  setTimeout(() => {
    getBusinessAppointment(dispatch, selector?.user?.business_id,`${dateState.selectedDate?.getFullYear()}-${dateState.selectedDate?.getMonth()+1}-${dateState.selectedDate?.getDate()}`);
  }, 300);
  const message = "Hi "+ patientName + ",\nYour appointment is cancelled for " + startDate+ " at " + startTime2 + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
  
  setTimeout(() => {
      window.open(whatsappUrl, '_blank');
  }, 900);
console.log(id)


}
const handleCompleteAppointmentMain =(id)=>{
  completeBusinessAppointment(dispatch,id,selectedPaymentMethod);
  // console.log(id, selectedPaymentMethod);
  setTimeout(() => {
    getBusinessAppointment(dispatch, selector?.user?.business_id,`${dateState.selectedDate?.getFullYear()}-${dateState.selectedDate?.getMonth()+1}-${dateState.selectedDate?.getDate()}`);
  }, 300);
}


const handleRescheduleAppointmentMain =(values)=>{
  // console.log(editId);
  console.log(patientName)
  const req2 = {
    start_time:values.start_time,
    start_date:values.start_date,
    end_date:values.end_date,
    end_time:values.end_time,
    staff:values.staff_id,
    reason:values.reason,
  }
  console.log(appointmenttoReschedule,req2);
  rescheduleBusinessAppointment(dispatch,appointmenttoReschedule,req2);
  setTimeout(() => {
    getBusinessAppointment(dispatch, selector?.user?.business_id,`${dateState.selectedDate?.getFullYear()}-${dateState.selectedDate?.getMonth()+1}-${dateState.selectedDate?.getDate()}`);
  }, 300);
    const message = "Hi "+ patientName + ",\nYour appointment is rescheduled for " + values.start_date+ " at " + values.start_time + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
    
    setTimeout(() => {
        window.open(whatsappUrl, '_blank');
    }, 900);


}
const handleSendNotification = () =>{
  const whatsappCheckbox = document.getElementById('whatsappCheckbox');
  const isWhatsAppChecked = whatsappCheckbox.checked;
  const smsCheckbox = document.getElementById('smsCheckbox');
  const isSmsChecked = smsCheckbox.checked;
  
  if(isWhatsAppChecked){
    let status = appointmentStatus;
    const dateString = startDate2;
    const date = new Date(dateString);
  const formattedDate = date.toISOString().split('T')[0];
    if(status === 'pending'){
      const message = "Hi "+ patientName + ",\nYour appointment is successfully booked on " + formattedDate + " at " + startTime2 + "\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
      successMessage(dispatch,"Message Sent")
      setTimeout(() => {
          window.open(whatsappUrl, '_blank');
      }, 900);
  
    }
    else if(status==='cancelled'){
      const message = "Hi "+ patientName + ",\nYour appointment is cancelled for " + formattedDate+ " at " + startTime2 + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
      successMessage(dispatch,"Message Sent")
      setTimeout(() => {
          window.open(whatsappUrl, '_blank');
      }, 900);
    }
    else if(status==='rescheduled'){
      const message = "Hi "+ patientName + ",\nYour appointment is rescheduled for " + formattedDate+ " at " + startTime2 + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
      successMessage(dispatch,"Message Sent")
      setTimeout(() => {
          window.open(whatsappUrl, '_blank');
      }, 900);
    }
    else if(status==='completed'){
      const message = "Hi "+ patientName + ",\nYour appointment is completed for " + formattedDate+ " at " + startTime2 + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
      const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
      successMessage(dispatch,"Message Sent")
      setTimeout(() => {
          window.open(whatsappUrl, '_blank');
      }, 900);
    }
  else{
    errorMessage(dispatch,"Error")
  }
  
  }
else if(isSmsChecked){
console.log("only sms")
}
else if(isWhatsAppChecked && isSmsChecked){
  let status = appointmentStatus;
  const dateString = startDate2;
  const date = new Date(dateString);
const formattedDate = date.toISOString().split('T')[0];
  if(status === 'pending'){
    const message = "Hi "+ patientName + ",\nYour appointment is successfully booked on " + formattedDate + " at " + startTime2 + "\nThank You!\n\nTeam- "+ selector.details.name +"\nContact- "+ selector.details.contact +"\ntheappointmentapp.com";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
    successMessage(dispatch,"Message Sent")
    setTimeout(() => {
        window.open(whatsappUrl, '_blank');
    }, 900);

  }
  else if(status==='cancelled'){
    const message = "Hi "+ patientName + ",\nYour appointment is cancelled for " + formattedDate+ " at " + startTime2 + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
    successMessage(dispatch,"Message Sent")
    setTimeout(() => {
        window.open(whatsappUrl, '_blank');
    }, 900);
  }
  else if(status==='rescheduled'){
    const message = "Hi "+ patientName + ",\nYour appointment is rescheduled for " + formattedDate+ " at " + startTime2 + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
    successMessage(dispatch,"Message Sent")
    setTimeout(() => {
        window.open(whatsappUrl, '_blank');
    }, 900);
  }
  else if(status==='completed'){
    const message = "Hi "+ patientName + ",\nYour appointment is completed for " + formattedDate+ " at " + startTime2 + "\nWe look forward to serve you soon.\nThank You!\n\nTeam- "+ selector?.user?.name +"\nContact- "+ selector?.user?.contact +"\ntheappointmentapp.com";
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${patientContact}&text=${encodeURIComponent(message)}`;
    successMessage(dispatch,"Message Sent")
    setTimeout(() => {
        window.open(whatsappUrl, '_blank');
    }, 900);
  }
else{
  errorMessage(dispatch,"Error")
}

  console.log("Both are selected")
}
else{
  errorMessage(dispatch,'Please Select atleast one option')
}
}
  const dateState = useSelector(state=>state.date);
  useEffect(() => {
    getBusinessAppointment(dispatch, selector?.user?.business_id,`${dateState.selectedDate?.getFullYear()}-${dateState.selectedDate?.getMonth()+1}-${dateState.selectedDate?.getDate()}`);
}, [dateState.selectedDate])


return (
<AppLayout>
  <AppointmentForm
    open={sidebarOpen}
    onClose={() => {
      setSidebarOpen(false);
      setEditId(0);
      setSelectedAppointmentData(null);
    }}
    mode={sidebarMode}
    data={selectedAppointmentData}
    onSubmit={async (values) => {
      try {
        if (sidebarMode === "add") {
          await addbusinessAppointment(dispatch, {}, values);
        } else {
          const req2 = {
            start_time: values.start_time,
            start_date: values.start_date,
            end_date: values.end_date,
            end_time: values.end_time,
            staff: values.staff_id,
            reason: values.reason || '',
            notes: values.notes || '',
            appointment_type: values.appointment_type || '',
            location: values.location || '',
            payment_method: values.payment_method || '',
            payment_status: values.payment_status || '',
            priority: values.priority || 'normal',
            meet_link: values.meet_link || null,
            custom_fields: values.custom_fields || {},
          };
          await rescheduleBusinessAppointment(dispatch, editId, req2);
        }
        setSidebarOpen(false);
        setEditId(0);
        setSelectedAppointmentData(null);
        refreshAppointment();
        successMessage(dispatch, sidebarMode === "add" ? "Appointment created successfully!" : "Appointment updated successfully!");
      } catch (error) {
        console.error('Error saving appointment:', error);
        errorMessage(dispatch, error?.message || 'Failed to save appointment');
      }
    }}
  />

<Box sx={{ 
  width: '100%', 
  height: '100%', 
  display: 'flex', 
  flexDirection: 'column', 
  overflow: 'hidden',
  gap: 1,
  p: 1
}}>
<Header
title={labels.appointments || 'Appointments'}
middle={<>
<IconButton 
  onClick={refreshAppointment}
  sx={{
    bgcolor: 'rgba(102, 126, 234, 0.1)',
    color: '#667eea',
    '&:hover': {
      bgcolor: 'rgba(102, 126, 234, 0.2)',
    },
  }}
>
  <MdRefresh/>
</IconButton>
<Button
  variant={calendarView ? 'contained' : 'outlined'}
  onClick={() => setCalendarView(true)}
  sx={{
    ml: 1,
    borderRadius: '12px',
    textTransform: 'none',
    px: 2,
    py: 0.75,
    background: calendarView ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
    borderColor: calendarView ? 'transparent' : '#667eea',
    color: calendarView ? 'white' : '#667eea',
    fontWeight: calendarView ? 600 : 500,
    '&:hover': {
      background: calendarView ? 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)' : 'rgba(102, 126, 234, 0.1)',
      borderColor: '#667eea',
    },
  }}
>
  Calendar
</Button>
<Button
  variant={!calendarView ? 'contained' : 'outlined'}
  onClick={() => setCalendarView(false)}
  sx={{
    ml: 1,
    borderRadius: '12px',
    textTransform: 'none',
    px: 2,
    py: 0.75,
    background: !calendarView ? 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' : 'transparent',
    borderColor: !calendarView ? 'transparent' : '#667eea',
    color: !calendarView ? 'white' : '#667eea',
    fontWeight: !calendarView ? 600 : 500,
    '&:hover': {
      background: !calendarView ? 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)' : 'rgba(102, 126, 234, 0.1)',
      borderColor: '#667eea',
    },
  }}
>
  Table
</Button>
</>}
actions={<>
<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
  <Button
    variant="contained"
    onClick={()=>{
      setSidebarMode("add");
      setSelectedAppointmentData(null);
      setEditId(0);
      setSidebarOpen(true);
    }}
    sx={{
      minWidth: 'auto',
      width: 40,
      height: 40,
      borderRadius: '50%',
      p: 0,
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
      '&:hover': {
        background: 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)',
        boxShadow: '0 6px 20px rgba(102, 126, 234, 0.5)',
      },
    }}
  >
    <span style={{ fontSize: '24px', lineHeight: 1 }}>+</span>
  </Button>
</Box>
</>}
/>
    {calendarView ? (
      <Box sx={{ width: '100%', flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ px: 1, pt: 0, flexShrink: 0 }}>
          <AppointmentCalendar
          appointments={businessSelector?.appointments || []}
          selectedDate={dateState.selectedDate}
          onDateChange={(date) => {
            dispatch(setSelectedDate(date));
          }}
          onAppointmentClick={(appointment) => {
            // Handle appointment click - could show details modal
            console.log('Appointment clicked:', appointment);
          }}
          onEdit={(appointment) => {
            setEditId(appointment.appointment_id);
            setSelectedAppointmentData(appointment);
            setStateForm({...appointment});
            setSidebarMode("edit");
            setSidebarOpen(true);
          }}
          onDelete={(appointment) => {
            setAppointmenttodelete(appointment.appointment_id);
            setShowConfirmationPopup(true);
          }}
          onComplete={(appointment) => {
            setAppointmenttocomplete(appointment.appointment_id);
            setShowConfirmationPopupComplete(true);
          }}
          onCancel={(appointment) => {
            setAppointmenttocancel(appointment.appointment_id);
            setPatientName(appointment.patient_name);
            setPatientContact(appointment.contact);
            setStartDate2(appointment.start_date);
            setStartTime2(appointment.start_time);
            setShowConfirmationPopupCancel(true);
          }}
          onCreateAppointment={(date) => {
            setSidebarMode("add");
            setSelectedAppointmentData(null);
            setEditId(0);
            setSidebarOpen(true);
          }}
          onStatusChange={async (appointmentId, newStatus) => {
            try {
              await updateAppointmentStatus(dispatch, appointmentId, newStatus);
              refreshAppointment();
            } catch (error) {
              console.error('Error updating appointment status:', error);
            }
          }}
        />
        </Box>
      </Box>
    ) : (
      <Box sx={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0 }}>
        <Box sx={{ px: { xs: 2, md: 4 }, py: 0.5, width: '100%', flexShrink: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
            <IconButton 
              onClick={()=>removeDate(dispatch)} 
              sx={{
                bgcolor: '#f3f4f6',
                color: '#667eea',
                '&:hover': {
                  bgcolor: 'rgba(102, 126, 234, 0.1)',
                },
              }}
            >
              <MdArrowBackIos size={'1rem'}/>
            </IconButton>
            <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', gap: { xs: 1, md: 2 } }}>
              {/* Mobile Date View */}
              <Box sx={{ display: { xs: 'flex', lg: 'none' }, gap: 1, overflowX: 'auto', width: '100%', justifyContent: 'center' }}>
                {dateState.datesMobile.map((e,i) => (
                  <Box
                    key={i}
                    onClick={()=>dispatch(setSelectedDate(e))}
                    sx={{
                      cursor: 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      px: 2,
                      py: 1.5,
                      borderRadius: '12px',
                      minWidth: 60,
                      transition: 'all 0.2s',
                      border: compareDate(e,dateState.selectedDate) ? '2px solid #667eea' : '2px solid transparent',
                      bgcolor: compareDate(e,dateState.selectedDate) ? 'rgba(102, 126, 234, 0.1)' : 'transparent',
                      '&:hover': {
                        bgcolor: 'rgba(102, 126, 234, 0.05)',
                      },
                    }}
                  >
                    <Typography variant="caption" sx={{ fontSize: '0.7rem', color: compareDate(e,dateState.selectedDate) ? '#667eea' : '#6b7280', fontWeight: compareDate(e,dateState.selectedDate) ? 600 : 400 }}>
                      {returnMonth(e)}
                    </Typography>
                    <Typography variant="h6" sx={{ fontSize: '1.25rem', fontWeight: 600, color: compareDate(e,dateState.selectedDate) ? '#667eea' : '#1f2937' }}>
                      {e?.getDate()}
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: '0.7rem', color: '#9ca3af', textTransform: 'uppercase' }}>
                      {returnWeek(e)}
                    </Typography>
                  </Box>
                ))}
              </Box>
              {/* Desktop Date View */}
              <Box sx={{ display: { xs: 'none', lg: 'flex' }, gap: 2, width: '100%', justifyContent: 'center' }}>
                {dateState.dates.map((e,i) => (
                  <Box
                    key={i}
                    onClick={()=>dispatch(setSelectedDate(e))}
                    sx={{
                      cursor: 'pointer',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      px: 3,
                      py: 2,
                      borderRadius: '12px',
                      minWidth: 70,
                      transition: 'all 0.2s',
                      border: compareDate(e,dateState.selectedDate) ? '2px solid #667eea' : '2px solid transparent',
                      bgcolor: compareDate(e,dateState.selectedDate) ? 'rgba(102, 126, 234, 0.1)' : 'transparent',
                      '&:hover': {
                        bgcolor: 'rgba(102, 126, 234, 0.05)',
                      },
                    }}
                  >
                    <Typography variant="caption" sx={{ fontSize: '0.75rem', color: compareDate(e,dateState.selectedDate) ? '#667eea' : '#6b7280', fontWeight: compareDate(e,dateState.selectedDate) ? 600 : 400 }}>
                      {returnMonth(e)}
                    </Typography>
                    <Typography variant="h5" sx={{ fontSize: '1.5rem', fontWeight: 600, color: compareDate(e,dateState.selectedDate) ? '#667eea' : '#1f2937' }}>
                      {e?.getDate()}
                    </Typography>
                    <Typography variant="caption" sx={{ fontSize: '0.75rem', color: '#9ca3af', textTransform: 'uppercase' }}>
                      {returnWeek(e)}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
            <IconButton 
              onClick={()=>addDate(dispatch)} 
              sx={{
                bgcolor: '#f3f4f6',
                color: '#667eea',
                '&:hover': {
                  bgcolor: 'rgba(102, 126, 234, 0.1)',
                },
              }}
            >
              <MdArrowForwardIos size={'1rem'}/>
            </IconButton>
          </Box>
        </Box>
        <Box sx={{ width: '100%', flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0, px: { xs: 2, md: 4 }, pt: 0.5 }}>
          <AppointmentTable
            setEditMode={(data) => {
              setEditId(data?.appointment_id);
              setStateForm({...data})
              setSelectedAppointmentData(data);
              setSidebarMode("edit");
              setSidebarOpen(true);
            }}
            setEditAppointment={(data,patientName,patientContact) => {
              setAppointmenttoreschedule(data)
              setPatientName(patientName)
              setPatientContact(patientContact)
              setStateForm({...data})
              setEditId(data?.appointment_id);
              setSelectedAppointmentData(data);
              setSidebarMode("edit");
              setSidebarOpen(true);
            }}
            onDeleteAppointment={(data) => {
              setAppointmenttodelete(data);
              setShowConfirmationPopup(true);
            }}
            onCompleteAppointment={(data) => {
              setAppointmenttocomplete(data);
              setShowConfirmationPopupComplete(true);
            }}
            onPatientDetails={(data,patientName,patientContact,patient_id)=>{
              setPatientDetails(data);
              setPatientName(patientName)
              setPatientContact(patientContact)
              setPatientID(patient_id)
              setShowPatientDetailsPopUp(true);
            }}
            onSendNotification={(data,patientName,patientContact,startDate2,startTime2,appointmentStatus)=>{
              setSendNotificationID(data)
              setPatientName(patientName)
              setPatientContact(patientContact)
              setStartDate2(startDate2)
              setStartTime2(startTime2)
              setAppointmentStatus(appointmentStatus)
              setShowSendNotification(true);
            }}
            onCancelAppointment={(data,patientName,patientContact,startDate2,startTime2) => {
              setAppointmenttocancel(data);
              setPatientName(patientName);
              setPatientContact(patientContact);
              setStartDate2(startDate2);
              setStartTime2(startTime2);
              setShowConfirmationPopupCancel(true);
            }}
          />
        </Box>
      </Box>
    )}
</Box>
    <Dialog
      open={!!showPatientDetailsPopUp}
      onClose={() => setShowPatientDetailsPopUp(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        },
      }}
    >
      <DialogTitle
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {labels.customer || "Customer"} Details
        </Typography>
        <IconButton
          onClick={() => setShowPatientDetailsPopUp(false)}
          sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' } }}
        >
          <RxCross2 size={24} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              Name
            </Typography>
            <Typography variant="body1" sx={{ fontSize: '1.1rem', fontWeight: 500, color: 'text.primary' }}>
              {patientName || '-'}
            </Typography>
          </Box>
          <Divider />
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.5 }}>
              Contact
            </Typography>
            <Typography variant="body1" sx={{ fontSize: '1.1rem', fontWeight: 500, color: 'text.primary' }}>
              {patientContact || '-'}
            </Typography>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, pt: 0 }}>
        <Button
          onClick={() => setShowPatientDetailsPopUp(false)}
          variant="contained"
          fullWidth
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '8px',
            textTransform: 'none',
            py: 1.25,
            fontWeight: 600,
            '&:hover': {
              background: 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)',
            },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog
      open={showSendNotification}
      onClose={() => setShowSendNotification(false)}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        },
      }}
    >
      <DialogTitle
        sx={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          py: 2,
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          Resend Notification
        </Typography>
        <IconButton
          onClick={() => setShowSendNotification(false)}
          sx={{ color: 'white', '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.1)' } }}
        >
          <RxCross2 size={24} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, fontWeight: 500 }}>
              Send notification to:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, bgcolor: '#f9fafb', p: 2, borderRadius: '8px' }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                  Name
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {patientName || '-'}
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600 }}>
                  Contact
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {patientContact || '-'}
                </Typography>
              </Box>
            </Box>
          </Box>
          <Divider />
          <Box>
            <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2, fontWeight: 500 }}>
              Select notification method:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  p: 1.5,
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  '&:hover': {
                    bgcolor: '#f9fafb',
                  },
                }}
              >
                <Checkbox
                  id="whatsappCheckbox"
                  defaultChecked
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
                <label htmlFor="whatsappCheckbox" style={{ cursor: 'pointer', flex: 1, marginLeft: 8 }}>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    WhatsApp
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Send via WhatsApp
                  </Typography>
                </label>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  p: 1.5,
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb',
                  '&:hover': {
                    bgcolor: '#f9fafb',
                  },
                }}
              >
                <Checkbox
                  id="smsCheckbox"
                  sx={{
                    color: '#667eea',
                    '&.Mui-checked': {
                      color: '#667eea',
                    },
                  }}
                />
                <label htmlFor="smsCheckbox" style={{ cursor: 'pointer', flex: 1, marginLeft: 8 }}>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    SMS
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                    Send via SMS
                  </Typography>
                </label>
              </Box>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2.5, pt: 0, gap: 1 }}>
        <Button
          onClick={() => setShowSendNotification(false)}
          variant="outlined"
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            py: 1.25,
            px: 3,
            borderColor: '#e5e7eb',
            color: 'text.secondary',
            '&:hover': {
              borderColor: '#d1d5db',
              bgcolor: '#f9fafb',
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            handleSendNotification();
            setShowSendNotification(false);
          }}
          variant="contained"
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '8px',
            textTransform: 'none',
            py: 1.25,
            px: 3,
            fontWeight: 600,
            '&:hover': {
              background: 'linear-gradient(135deg, #5568d3 0%, #6a3d8f 100%)',
            },
          }}
        >
          Send Notification
        </Button>
      </DialogActions>
    </Dialog>
    {showConfirmationPopup && (
    <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 w-[90%]  md:w-[40%]  flex flex-col z-50 bg-white text-black border-black border-[1px] pt-4 pb-4 pl-3 pr-3 rounded-lg">
    <h3 className=" text-center text-xl">Are you sure you want to delete this appointment?</h3>
      <div className="flex flex-row justify-center mt-5">
      <button className=" bg-blue-600 pl-5 pr-5 pt-2 pb-2 text-white rounded-xl" onClick={() => setShowConfirmationPopup(false)}>No</button>
      <button className=" bg-red-600 pl-5 pr-5 pt-2 pb-2 text-white rounded-xl ml-5  "
        onClick={() => {
            handleDeleteAppointmentMain(appointmenttoDelete);
            setShowConfirmationPopup(!showConfirmationPopup);
          }
        }
      >
        Yes
      </button>
      </div>
    </div>
  )}
    {showConfirmationPopupCancel && (
    // <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 w-[90%] sm:w-[80%] md:w-[60%] lg:w-[40%] xl:w-[30%] flex flex-col z-50 bg-white text-black border-black border-[1px] pt-4 pb-4 pl-3 pr-3 rounded-lg">
    <div className="absolute top-[40%] left-1/2 transform -translate-x-1/2 w-[90%]  md:w-[40%]  flex flex-col z-50 bg-white text-black border-black border-[1px] pt-4 pb-4 pl-3 pr-3 rounded-lg">
    <h3 className="text-center text-xl">Are you sure you want to cancel this appointment?</h3>
    <div className="flex flex-row justify-center mt-3">
      <button
        className="bg-blue-600 px-3 py-2 text-white rounded-md mr-2"
        onClick={() => setShowConfirmationPopupCancel(false)}
      >
        No
      </button>
      <button
        className="bg-red-600 px-3 py-2 text-white rounded-md ml-2"
        onClick={() => {
          handleCancelAppointmentMain(appointmenttoCancel);
          setShowConfirmationPopupCancel(!showConfirmationPopupCancel);
        }}
      >
        Yes
      </button>
    </div>
  </div>
  
  )}

    {/* {showConfirmationPopupReschedule && (
    <>
    <RescheduleForm 
            data={stateForm} 
            onCancel={() => {
              setSidebarOpen(false);
              setEditId(0);
              setSelectedAppointmentData(null);
            }}
            onSubmit={(values2) => {
              handleRescheduleAppointmentMain(values2);
            }}
          />
    </>
  )} */}
{showConfirmationPopupComplete && (
  <div className="absolute w-full sm:w-[80%] md:w-[60%] lg:w-[40%] xl:w-[30%] top-[30%] left-1/2 transform -translate-x-1/2 bg-white text-black border-black border-[1px] pt-10 pb-10 pl-5 pr-5 rounded-2xl z-50">
    <span
      className="absolute top-2 right-2 cursor-pointer"
      onClick={() => setShowConfirmationPopupComplete(false)}
    >
      <RxCross2 size={24} />
    </span>
    <h3 className="text-left text-xl">Paid By:</h3>
    <div className="flex flex-col items-start mt-5">
      <label className="mb-2 flex justify-start items-center">
        <input
          type="checkbox"
          value="cash"
          className="cursor-pointer mr-2"
          checked={selectedPaymentMethod === 'cash'}
          onChange={() => handlePaymentMethodChange('cash')}
        />
        <p>Cash</p>
      </label>
      <label className="mb-2 flex justify-start items-center">
        <input
          type="checkbox"
          value="upi"
          className="cursor-pointer mr-2"
          checked={selectedPaymentMethod === 'upi'}
          onChange={() => handlePaymentMethodChange('upi')}
        />
        <p>UPI</p>
      </label>
      <label className="mb-2 flex justify-start items-center">
        <input
          type="checkbox"
          value="netbanking"
          className="cursor-pointer mr-2"
          checked={selectedPaymentMethod === 'netbanking'}
          onChange={() => handlePaymentMethodChange('netbanking')}
        />
        <p>Netbanking</p>
      </label>
    </div>
    <div className="flex flex-row justify-center mt-5">
      <button
        className="button w-full"
        onClick={() => {
          handleCompleteAppointmentMain(appointmenttoComplete);
          setShowConfirmationPopupComplete(false);
        }}
      >
        Proceed
      </button>
    </div>
    {selectedPaymentMethod && (
      <p className="mt-3 flex justify-center">
        Selected Payment Method:
        <span className="ml-2 pl-2 pr-2 rounded-md border-blue-700 border-2 cursor-default">
          {selectedPaymentMethod}
        </span>
      </p>
    )}
  </div>
)}
</AppLayout>
)
}
export const AppointmentPopup = ({ closePopup }) => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state.business);
  const labels = useLabels();
  useEffect(() => {
    
    getBusinessPatients(dispatch, selector.details.business_id);
    getBusinessServices(dispatch, selector.details.business_id);
    getBusinessStaff(dispatch, selector.details.business_id);
  }, []);
  // const [filterContact, setFilterContact] = useState(" "); 
  const [selectedContact, setSelectedContact] = useState('');
  const [selectedPatient, setSelectedPatient] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(''); // Keep for backward compatibility
  const [appointment, setappointment] = useState({
    time: dayjs(new Date().toISOString()),
    date: dayjs(new Date().toISOString()),
    reason: "",
    duration: 15,
    staff: 0,
    customer: 0,
    service: "",
  });

  const nav = useNavigate();
  // const getCustomerContact = (customerId) => {
  //   const customer = selector.customers.find((c) => c.customer_id === customerId);
  //   return customer ? customer.contact : null;
  // };  
  const onSubmit = () => {
    console.log(appointment);
    getBusinessDetails(dispatch,selector.details.business_id)

    // const patientContact = getCustomerContact(appointment.customer);
    console.log("Customer Contact:", selectedContact);
    console.log("Customer ID:", appointment.customer);
    if (
      appointment.customer !== 0 &&
      appointment.customer !== "" &&
      appointment.service !== 0 &&
      appointment.service !== "" &&
      appointment.service !== "0" &&
      appointment.staff !== "" &&
      appointment.staff !== 0
    ) {
      const end = appointment.time.add(appointment.duration, "minutes");
      const req = {
        
        start_time:
          (appointment.time.hour() < 10
            ? `0${appointment.time.hour()}`
            : appointment.time.hour()) +
          ":" +
          (appointment.time.minute() < 10
            ? `0${appointment.time.minute()}`
            : appointment.time.minute()) +
          ":00",
        end_time:
          (end.hour() < 10 ? `0${end.hour()}` : end.hour()) +
          ":" +
          (end.minute() < 10 ? `0${end.minute()}` : end.minute()) +
          ":00",
        start_date:
          appointment.date.year() +
          "-" +
          ((appointment.date.month()+1) < 10
            ? `0${(appointment.date.month()+1)}`
            : (appointment.date.month()+1)) +
          "-" +
          (appointment.date.date() < 10
            ? `0${appointment.date.date()}`
            : appointment.date.date()),
        end_date:
          appointment.date.year() +
          "-" +
          (appointment.date.month() < 10
            ? `0${appointment.date.month()}`
            : appointment.date.month()) +
          "-" +
          (appointment.date.date() < 10
            ? `0${appointment.date.date()}`
            : appointment.date.date()),
        reason: appointment.reason,
        staff_id: appointment.staff,
        customer_id: appointment.patient || appointment.customer, // Validator requires customer_id
        patient_id: appointment.patient || appointment.customer, // Also send patient_id for backward compatibility
        service_id: appointment.service,
        
      };
      const req2 = {
        contact: selectedContact,
        patient_name: selectedPatient || selectedCustomer,
        customer_name: selectedPatient || selectedCustomer, // Keep for backward compatibility
        name: selector.details.name,
        businessContact: selector.details.contact
      }
      // console.log("Selected Customer Contact:", filteredCustomers.map((el,i) => {console.log(el.contact)}));
      console.log(req,'vraj');
      addbusinessAppointment(
        dispatch,
        req2,

        req,
        () => {
          setappointment({
            time: dayjs(new Date().toISOString()),
            date: dayjs(new Date().toISOString()),
            reason: "",
            duration: 15,
            staff: 0,
            patient: 0,
            customer: 0, // Keep for backward compatibility
            service: "",

          });
          closePopup();
        }
      );
      // setTimeout(() => {
      //   getBusinessAppointment();
      // }, 300);
      const message = "Hi "+ (selectedPatient || selectedCustomer) + ",\nYour appointment is successfully booked on " + req.start_date+ " at " + req.start_time + "\nThank You!\n\nTeam- "+ selector.details.name +"\nContact- "+ selector.details.contact +"\ntheappointmentapp.com";

      const whatsappUrl = `https://api.whatsapp.com/send?phone=+91 ${selectedContact}&text=${encodeURIComponent(message)}`;
      setTimeout(() => {
          window.open(whatsappUrl, '_blank');
      }, 900);
  
    } else {
      dispatch(failedBookAppointment({ message: "Please fill all details!" }));
    }
  };
  const [searchText, setSearchText] = useState("");
  const [ShowSearchBar, setShowSearchBar] = useState("");
  const [showPatientPopup, setShowPatientPopup] = useState(false);

  const filteredCustomers = selector.customers?.filter((el,i) =>
  el.full_name.toLowerCase().includes(searchText.toLowerCase()),
  );
  // const filterContact = filteredCustomers.map((el,i)=>{
  //   return el.contact
  // })

  
  // const [customersContact, setCustomersContact] = useState([]);

//   useEffect(() => {
//     // Fetch customers and set them in state
//     getBusinessCustomers(dispatch,selector.details.business_id)
//       .then((data) => setCustomersContact(data?.data))
//       .catch((error) => console.log(error));
//   },[dispatch,selector.details.business_id]);

// console.log(customersContact);
// const patientContact = getCustomerContact(appointment.customer);
  
// console.log(filterContact);
// const handleCustomerChange = (ev) => {
//   const selectedCustomerId = ev.target.value;
//   setappointment((prev) => ({ ...prev, customer: selectedCustomerId }));
  
//   const selectedCustomer = filteredCustomers.find(
//     (el) => el.customer_id === selectedCustomerId
//   );
  
//   if (selectedCustomer) {
//     setFilterContact(selectedCustomer.contact);
//   } else {
//     setFilterContact(""); // Reset contact if customer not found
//   }
// };
// console.log('Customer Contact:', CUSTOMERS);

  console.log(selector.services);
  return (
    <div className="w-screen z-20 h-screen left-0 top-0 fixed bg-black/40 flex items-center justify-center">
      {/* <Snackbar
        open={selector.errorBook}
        autoHideDuration={6000}
        onClose={() => {
          dispatch(removeAppointmentError());
        }}
        message={selector.errorMessage}
        action={<MdClose onClick={() => dispatch(removeAppointmentError())} />}
      /> */}

      <div className="w-[90%] lg:w-[60%] min-h-[60%] p-10 bg-white rounded-lg relative flex items-center gap-[1.6rem] sm:gap-10 flex-col">
        <span
          onClick={closePopup}
          className="cursor-pointer absolute top-4 right-4"
        >
          <MdClose />
        </span>
        <h2>Book Appointment</h2>
        <div className=" flex items-center justify-center w-full">
        <button className="button " onClick={() => setShowPatientPopup(true)}>Add Patient</button>
        {showPatientPopup && <PatientPopup closePopup={() => setShowPatientPopup(false)} />}
        </div>

        <div className=" flex justify-end items-end w-[100%]">
        
        {ShowSearchBar && (
    <div className="search-popup absolute z-50 w-[60%] right-[30%] top-[25.5%] md:right-[16%]   md:w-[80%]">
    <input
            type="text"
            placeholder="Search for customers..."
            value={searchText}
            onChange={(ev) => setSearchText(ev.target.value)}
            className=" absolute z-50 mb-2 px-2 py-1 border border-gray-300 rounded-md w-full overflow-y-scroll"
        />
        {/* Search results */}
        <div className=" mt-[2.5rem] h-[15rem] overflow-y-scroll bg-white">
        {filteredCustomers.map((el, i) => (
            <div
                key={el.customer_id}
                onClick={() => {
                    setappointment((prev) => ({
                        ...prev,
                        patient: el.patient_id,
                        customer: el.patient_id, // Keep for backward compatibility
                    }));
                    
                    setSelectedPatient(el.full_name);
                    setSelectedCustomer(el.full_name); // Keep for backward compatibility
                    setSelectedContact(el.contact);
                    setShowSearchBar(false);
                }}
                className="search-result cursor-pointer hover:bg-blue-600 hover:text-white text-center"
            >
              
                <span className=' mr-2'>{el.full_name}</span>-<span className=' ml-2'>{el.contact}</span>
            </div>
        ))}
        </div>
    </div>
)}
        <select
        name=""
        id=""
        placeholder={`Select ${labels.customer || "Customer"}`}
        value={appointment.customer}
        onChange={(ev) => {
          setappointment((prev) => ({ ...prev, patient: ev.target.value, customer: ev.target.value }));
          setSelectedContact(ev.target.selectedOptions[0].getAttribute("data-contact"));
          const selectedName = ev.target.selectedOptions[0].getAttribute("data-name");
          setSelectedPatient(selectedName);
          setSelectedCustomer(selectedName); // Keep for backward compatibility
          // const selectedCustomer = filteredCustomers.find(
          //   (el) => el.customer_id === ev.target.value
          // );
          // if (selectedCustomer) {
          //   setFilterContact(selectedCustomer.contact);
          // } else {
          //   setFilterContact("");
          // }
        }}
      >
        <option value="">Select {labels.customer?.toLowerCase() || "customer"}</option>
        {filteredCustomers.map((el, i) => (
          <option key={el.customer_id} value={el.customer_id} data-contact={el.contact} data-name={el.full_name}>
            {el.full_name}
            
          </option>
        ))}

      </select>
      <div className=" ml-5">
<IconButton ><MdSearch  onClick={() => setShowSearchBar((prev) => !prev)} /></IconButton>
</div>
      </div>
        {/* <select
        name=""
        id=""
        placeholder={`Select ${labels.customer || "Customer"}`}
        value={appointment.contact}
        onChange={(ev) => {
          setappointment((prev) => ({ ...prev, patient: ev.target.value, customer: ev.target.value }));
        }}
      >
        <option value="">Select {labels.customer?.toLowerCase() || "customer"}</option>
        {filteredCustomers.map((el, i) => (
          <option key={el.customer_id} value={el.customer_id}>
            {el.contact}
            
          </option>
        ))}
      </select> */}
      {/* <input
  type="text"
  value={selectedContact}
  readOnly
  className="border p-1 mt-2"
/> */}
        <select
          name=""
          id=""
          placeholder="Select Service"
          value={appointment.service}
          onChange={(ev) =>
            setappointment((prev) => ({ ...prev, service: ev.target.value }))
          }
        >
          <option value="">Select service</option>
          {selector.services?.map((el, i) => (
            <option value={el.service_id}>{el.service}</option>
          ))}
        </select>
        <select
          name=""
          id=""
          placeholder="Select Staff"
          value={appointment.staff}
          onChange={(ev) =>
            setappointment((prev) => ({ ...prev, staff: ev.target.value }))
          }
        >
          <option value="">Select staff</option>
          {selector.staff?.map((el, i) => (
            <option value={el.staff_id}>{el.name}</option>
          ))}
        </select>
        <InputComponents
          label={""}
          value={appointment.reason}
          onChange={(ev) =>
            setappointment((prev) => ({ ...prev, reason: ev.target.value }))
          }
          placeholder="Add a reason"
        />
        <div className="w-full flex items-center gap-4">
          <div className="flex-1">
            <DatePicker
              label="Start date"
              fullWidth
              variant="standard"
              value={appointment.date}
              onChange={(newValue) =>
                setappointment((prev) => ({ ...prev, date: newValue }))
              }
              format="DD-MM-YYYY"
            />
          </div>
          <div className="flex-1">
            <MobileTimePicker
              label="Start time"
              fullWidth
              variant="standard"
              value={appointment.time}
              onChange={(newValue) =>
                setappointment((prev) => ({ ...prev, time: newValue }))
              }
              format="hh:mm a"
            />
          </div>
          {/* <MobileTimePicker defaultValue={dayjs('2022-04-17T15:30')} onAccept={(val)=>console.log(val)} /> */}
          {/* <InputComponents
        label={''}
        placeholder='Add start time'
        type='date'
      /> */}
        </div>
        <select
          name=""
          id=""
          placeholder="Select Staff"
          value={appointment.duration}
          onChange={(ev) =>
            setappointment((prev) => ({ ...prev, duration: ev.target.value }))
          }
        >
          <option value={15}>
            15 mins
          </option>
          <option value={30}>
            30 mins
          </option>
          <option value={45}>
            45 mins
          </option>
          <option value={60}>
            60 mins
          </option>
        </select>
        <button onClick={onSubmit} className="button w-full">
          Book Appointment
        </button>
      </div>
    </div>
  );
};


// const AppointmentPopup = ({ closePopup }) => {
// const dispatch = useDispatch();
// useEffect(() => {
// getBusinessCustomers(dispatch, selector.details.business_id);
// getBusinessServices(dispatch, selector.details.business_id);
// getBusinessStaff(dispatch, selector.details.business_id);
// }, []);
// const selector = useSelector((state) => state.business);
// const [appointment, setappointment] = useState({
// time: dayjs(new Date().toISOString()),
// date: dayjs(new Date().toISOString()),

// duration: 15,
// staff: 0,
// customer: 0,
// service: "",
// });

// const nav = useNavigate();

// const onSubmit = () => {
// console.log(appointment);
// if (
//   appointment.customer !== 0 &&
//   appointment.customer !== "" &&
//   appointment.service !== 0 &&
//   appointment.service !== "" &&
//   appointment.service !== "0" &&
//   appointment.staff !== "" &&
//   appointment.staff !== 0
// ) {
//   const end = appointment.time.add(appointment.duration, "minutes");
//   const req = {
//     start_time:
//       (appointment.time.hour() < 10
//         ? `0${appointment.time.hour()}`
//         : appointment.time.hour()) +
//       ":" +
//       (appointment.time.minute() < 10
//         ? `0${appointment.time.minute()}`
//         : appointment.time.minute()) +
//       ":00",
//     end_time:
//       (end.hour() < 10 ? `0${end.hour()}` : end.hour()) +
//       ":" +
//       (end.minute() < 10 ? `0${end.minute()}` : end.minute()) +
//       ":00",
//     start_date:
//       appointment.date.year() +
//       "-" +
//       (appointment.date.month() < 10
//         ? `0${appointment.date.month()}`
//         : appointment.date.month()) +
//       "-" +
//       (appointment.date.date() < 10
//         ? `0${appointment.date.date()}`
//         : appointment.date.date()),
//     end_date:
//       appointment.date.year() +
//       "-" +
//       (appointment.date.month() < 10
//         ? `0${appointment.date.month()}`
//         : appointment.date.month()) +
//       "-" +
//       (appointment.date.date() < 10
//         ? `0${appointment.date.date()}`
//         : appointment.date.date()),
//     reason: appointment.reason,
//     staff_id: appointment.staff,
//     customer_id: appointment.customer,
//     service_id: appointment.service,
//   };
//   console.log(req);
//   dispatch(failedBookAppointment({ message: req.customer_id }));

//   addbusinessAppointment(
//     dispatch,
//     req,
//     () => {
//       setappointment({
//         time: dayjs(new Date().toISOString()),
//         date: dayjs(new Date().toISOString()),
//         reason: "",
//         duration: 0,
//         staff: 0,
//         customer: 0,
//         service: "",
//       });
//       closePopup();
//     }
//   );
// } else {
//   dispatch(failedBookAppointment({ message: "Please fill all details!" }));
// }
// };
// console.log(selector.services);
// return (
// <div className="w-screen z-20 h-screen left-0 top-0 fixed bg-black/40 flex items-center justify-center">
//   {/* <Snackbar
//     open={selector.errorBook}
//     autoHideDuration={6000}
//     onClose={() => {
//       dispatch(removeAppointmentError());
//     }}
//     message={selector.errorMessage}
//     action={<MdClose onClick={() => dispatch(removeAppointmentError())} />}
//   /> */}

// <div className="w-[90%] lg:w-[60%] min-h-[60%] p-10 bg-white rounded-lg relative flex items-center gap-10 flex-col">
//       <span
//         onClick={closePopup}
//         className="cursor-pointer absolute top-4 right-4"
//       >
//         <MdClose />
//       </span>
//       <h2>Book Appointment</h2>
//       <select
//         name=""
//         id=""
//         placeholder={`Select ${labels.customer || "Customer"}`}
//         value={appointment.customer}
//         onChange={(ev) =>
//           setappointment((prev) => ({ ...prev, customer: ev.target.value }))
//         }
//       >
//         <option value="">Select {labels.customer?.toLowerCase() || "customer"}</option>
//         {selector.customers?.map((el, i) => (
//           <option value={el.customer_id}>{el.full_name}</option>
//         ))}
//       </select>
//       <select
//         name=""
//         id=""
//         placeholder="Select Service"
//         value={appointment.service}
//         onChange={(ev) =>
//           setappointment((prev) => ({ ...prev, service: ev.target.value }))
//         }
//       >
//         <option value="">Select service</option>
//         {selector.services?.map((el, i) => (
//           <option value={el.service_id}>{el.service}</option>
//         ))}
//       </select>
//       <select
//         name=""
//         id=""
//         placeholder="Select Staff"
//         value={appointment.staff}
//         onChange={(ev) =>
//           setappointment((prev) => ({ ...prev, staff: ev.target.value }))
//         }
//       >
//         <option value="">Select staff</option>
//         {selector.staff?.map((el, i) => (
//           <option value={el.staff_id}>{el.name}</option>
//         ))}
//       </select>
//       <InputComponents
//         label={""}
//         value={appointment.reason}
//         onChange={(ev) =>
//           setappointment((prev) => ({ ...prev, reason: ev.target.value }))
//         }
//         placeholder="Add a reason"
//       />
//       <div className="w-full flex items-center gap-4">
//         <div className="flex-1">
//           <DateField
//             label="Start date"
//             fullWidth
//             variant="standard"
//             value={appointment.date}
//             onChange={(newValue) =>
//               setappointment((prev) => ({ ...prev, date: newValue }))
//             }
//             format="DD-MM-YYYY"
//           />
//         </div>
//         <div className="flex-1">
//           <TimeField
//             label="Start time"
//             fullWidth
//             variant="standard"
//             value={appointment.time}
//             onChange={(newValue) =>
//               setappointment((prev) => ({ ...prev, time: newValue }))
//             }
//             format="hh:mm a"
//           />
//         </div>
//         {/* <MobileTimePicker defaultValue={dayjs('2022-04-17T15:30')} onAccept={(val)=>console.log(val)} /> */}
//         {/* <InputComponents
//       label={''}
//       placeholder='Add start time'
//       type='date'
//     /> */}
//       </div>
//       <select
//         name=""
//         id=""
//         placeholder="Select Staff"
//         value={appointment.duration}
//         onChange={(ev) =>
//           setappointment((prev) => ({ ...prev, duration: ev.target.value }))
//         }
//       >
//         <option value={15}>
//           15 mins
//         </option>
//         <option value={30}>
//           30 mins
//         </option>
//         <option value={45}>
//           45 mins
//         </option>
//         <option value={60}>
//           60 mins
//         </option>
//       </select>
//       <button onClick={onSubmit} className="button w-full">
//         Book Appointment
//       </button>
//     </div>
// </div>
// );
// };

export default AppointmentScreen